<template>
    <html style="width:100%;overflow-x:hidden!important">
    <body style="position: relative;background: #fff;">
        <!--banner-->
        <section class="section">
            <img src="@/assets/styles/images-link/ban7.png" alt="">
        </section>
        <section class="section container03">
            <div class="da">
            <div class="zuo">
                <h2>系统介绍</h2>
                <h4>SYSTEM INTRODUCTION</h4>
                <p>省市县三级农政管理大数据平台是全省农村信息化重点工程的“核心”，主要采用统一标准、统一架构，服务于省、市、县三级农业政府部门、机关、事业单位以及广大农业用户；平台主要应用子系统包括：大数据门户、部门工作台、信息采集APP、信息综合管理系统。 </p>
            </div>
            <img src="@/assets/styles/images-link/n1.png" alt="" style="width: 90%;"> </div>
        </section>
        <section class="section container03 sjimg">
            <div class="da">
            <div class="zuo">
                <h2 style="color: #39bf3e">省级数据门户</h2>
                <h4>Provincial Data Portal</h4>
                <p style="font-size: 16px;line-height: 30px;color: #333">主要对省级数据进行统计分析展示，包括3+X产业概览、数字农业、数字乡村、数据服务、行业数据等板块。</p>
            </div>
            <img src="@/assets/styles/images-link/n2.png" alt=""> </div>
        </section>
        <section class="section container03">
            <div class="da">
            <div class="zuo">
                <h2>部门工作台</h2>
                <h4>Department Workbench</h4>
                <p>数据细分，根据各单位自身业务，为部门用户量身打造专属的数据工作台。 </p>
            </div>
            <img src="@/assets/styles/images-link/n3.png" alt="" style="margin-top: -40px"> </div>
        </section>
        <section class="section container03 dapingimg">
            <div class="da">
            <div class="zuo">
                <h2 style="color: #39bf3e">大屏展示系统</h2>
            </div>
            <img src="@/assets/styles/images-link/n5.png" alt="" style="margin-top: 40px;"> </div>
        </section>
        <section class="section container13">
            <div class="da">
            <div class="zuo">
                <h2 style="color: #39bf3e">农业指标信息采集系统（App）</h2>
                <h4 style="color: #999">Agricultural Index Information Collection System (App)</h4>
                <ul>
                <li> <img src="@/assets/styles/images-link/n7.png" alt="">
                    <p>信息采集</p>
                </li>
                <li> <img src="@/assets/styles/images-link/n8.png" alt="">
                    <p>图片视频采集</p>
                </li>
                <li> <img src="@/assets/styles/images-link/n9.png" alt="">
                    <p>工作排名</p>
                </li>
                </ul>
                <p >采集指标由信息综合管理系统统一管理，动态分配，实时采集。</p>
            </div>
            <img src="@/assets/styles/images-link/n6.png" alt="" class="you"> </div>
        </section>
    </body>
</html>
</template>
<style scoped>
    .sjimg{
        background: url('~@/assets/styles/images-link/bg11.png') center no-repeat;
        background-size: 100%
    }
    .dapingimg{
        background: url('~@/assets/styles/images-link/bg8.png') center no-repeat;
        background-size: 100%
    }
</style>

<script>

    import '@/assets/styles/css/zhihui1.css';   
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农政管理大数据综合服务系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
